module.exports = __webpack_public_path__ + "media/BaileIpssoBot_Hor.ad549f7b.webm";